import { Link } from "react-router-dom";

const TokenTerms = () => {
  return (
    <div className="policy container token-terms">
      <h1>Terms of Use for RXG Presale</h1>
      <h2 className="mt-0">
        <span>Release Date: 20th January 2025</span>
      </h2>

      <p>
        PLEASE READ THESE TERMS OF TOKEN SALE CAREFULLY. IT CONTAINS A BINDING
        ARBITRATION CLAUSE AND CLASS ACTION WAIVER, WHICH MAY AFFECT YOUR LEGAL
        RIGHTS. IF YOU DO NOT AGREE TO THESE TERMS OF SALE, DO NOT PURCHASE
        TOKENS.{" "}
      </p>

      <h4>Introduction</h4>
      <p>
        <b>
          Welcome to the RXG Presale site. The Terms of Use ('Terms') is your
          guide on how to access our website and services. By accessing or using{" "}
          <Link to="/ico" target="_blank">
            https://rexla.com/ico
          </Link>{" "}
          you agree to be bound by these Terms and acknowledge that they
          constitute a legal agreement between you and LA-Rex Limited (The
          Issuer of RXG)
        </b>
      </p>
      <p>
        Your purchase of RXG Tokens (collectively, “<b>RXG</b>” or “
        <b>Tokens</b>”) during the Token sale (the “<b>Token Sale</b>”) period
        (the “<b>Sale Period</b>”) from LA-Rex Limited, “<b>Company</b>,” “
        <b>we</b>,” or “<b>us</b>”) is subject to these Terms of Sale (“
        <b>Terms</b>”). Each of you and the Company is a “<b>Party</b>,” and
        together the “<b>Parties</b>.”
      </p>

      <h4>Description of Service</h4>
      <p>
        <b>
          LA-Rex Limited offers a digital platform for the sole purpose of sale
          and distribution of RXG Tokens. Our services are designed to
          facilitate users participating in the presale, subject to meeting our
          presale goals.
        </b>
      </p>

      <h4>Disclaimer</h4>
      <p>
        <b>
          The content and materials on the{" "}
          <Link to="/ico" target="_blank">
            https://rexla.com/ico
          </Link>{" "}
          are provided for general information purposes only. They are not
          intended as financial, investment, legal, or other professional
          advice. All information regarding the potential project and presale of
          RXG Tokens is tentative and subject to change. RXG token is issued by
          LA-Rex Limited, a company incorporated in the British Virgin Islands.
        </b>
      </p>
      <p>
        <b>
          By purchasing Tokens from us during the Sale Period, you will be bound
          by these Terms and all terms incorporated by reference. If you have
          any questions regarding these terms, please contact us at
          Support@Rexla.com
        </b>
      </p>

      <h4>Risk Acknowledgement</h4>
      <p>
        <b>
          Cryptocurrency investment holds a higher risk level. You acknowledge
          that the value of RXG coins is highly volatile and that the project is
          dependent on the success of the presale. LA-Rex Limited does not
          guarantee any specific outcomes or the successful launch of the
          project. You acknowledge and agree that there are risks associated
          with purchasing Tokens, holding Tokens and using Tokens for providing
          or receiving Services on the Platform, as disclosed and explained in
          this document.
        </b>
      </p>
      <p>
        <b>
          BY ACCEPTING THESE TERMS AND PURCHASING TOKENS, YOU EXPRESSLY AND
          FINALLY ACKNOWLEDGE, ACCEPT AND ASSUME ALL OF THE RISKS SET FORTH IN
          THIS DOCUMENT HERETO. ALL RISK OF LOSS TRANSFERS TO YOU UPON PURCHASE
          OF THE TOKENS.
        </b>
      </p>

      <div>
        <p>You and the Company agree as follows:</p>
        <h5>1. Purpose and Use of Tokens</h5>
        <p>
          The purpose of the Tokens is to be used for payment from services via
          the Rexla Hub, a service provided by Rexla Global, and to grant
          discounts against these services, as described further in the “
          <b>White Paper</b>”.
        </p>
        <p>
          {" "}
          The Tokens do not confer any rights, express or implied, other than
          the right to use the Token as a means to participate in the Platform,
          if successfully completed and deployed, in a manner consistent with
          its purpose. In particular, you understand and accept that the Token
          does not represent or confer any ownership right or stake, share or
          security or equivalent rights, or any right to receive future share of
          revenue, intellectual property rights or any other form of
          participation in or relating to the Platform, and/or the Company and
          its corporate affiliates, other than rights relating to the use of the
          Platform, subject to limitations and conditions in these Terms and
          applicable Platform Terms and Policies (as defined below). The Tokens
          are not intended to be a digital currency, security, commodity or any
          other kind of financial instrument.
        </p>

        <h5>2. Scope of Terms</h5>
        <p>
          Unless otherwise stated herein, these Terms govern only your purchase
          of Tokens from us during the Sale Period. The use of Tokens in
          connection with the Platform may be governed by other applicable terms
          and policies (collectively, the “<b>Platform Terms and Policies</b>”).
          These are viewable at{" "}
          <Link to="/" target="_blank">
            <b>https://rexla.com</b>
          </Link>{" "}
          We may add terms or policies to the Platform Terms and Policies at our
          sole discretion, and may update each of the Platform Terms and
          Policies from time to time according to modification procedures set
          forth therein. To the extent of any conflict with these Terms, the
          Platform Terms and Policies shall control with respect to any issues
          relating to the use of Tokens in connection with the Platform.
        </p>

        <h5>3. Eligibility and Participation</h5>
        <p>
          To participate in the presale, you must meet specific eligibility
          criteria, which may include age, jurisdiction, and compliance with
          relevant laws. It is your responsibility to ensure that you are
          legally allowed to participate in the presale in your jurisdiction.
          Should you wish for your participation you are covered by a SAFT
          (Simple Agreement for Future Tokens) This can be made available to you
          on request – The document is accessible on the pre sale site.
        </p>
        <p>
          Further, in order to be eligible to participate in the Token Sale, you
          must provide all personal information as required by the Company or
          its agents, as part of its Know Your Customer (“<b>KYC</b>”) process.
          We may choose to nominate third party service providers to collect and
          verify KYC information on our behalf, who may also require you to
          accept their terms and conditions or privacy policy agreements.
          Collected information may include a passport, driver’s license,
          utility bill, photograph of you, government identification cards, or
          sworn statements, and we or our nominee may keep a copy of such
          information.{" "}
        </p>
        <p>
          In order to be eligible to purchase the Tokens, you must also have a
          wallet or other storage mechanism (“<b>Wallet</b>”) that supports Base
          Network native tokens in order to receive any Tokens you purchase from
          us and provide the address for your Wallet (the “
          <b>Token Receipt Address</b>”) if requested. We reserve the right to
          prescribe additional guidance regarding specific requirements with
          respect to a storage mechanism for the Tokens. You must have the
          ability to send USDC to the address that we provide (the “
          <b>Token Deposit Address</b>”).
        </p>
        <p>
          We are not responsible for any delays, losses, costs, non-delivery of
          refunds or of Tokens; or other issues arising from your failing to
          provide a Token Receipt Address or providing an inaccurate or
          incomplete Token Receipt Address.{" "}
        </p>
        <p>
          The Company reserves the right to prohibit any and all sales to users
          domiciled or located in a country or territory it deems as restricted
          from any token sale activities are subject to regulatory requirements,
          including but not limited to Afghanistan, Congo-Brazzaville,
          Congo-Kinshasa, Cuba, Iran, Iraq, Libya, North Korea, Syria and
          Tajikistan. The Company may cancel any sales to users domiciled or
          located in any such country.
        </p>

        <h5>4. Cancellation; Refusal of Purchase Requests</h5>
        <p>
          Your purchase of Tokens from us during the Sale Period is final, and
          there are no refunds or cancellations except (i) as may be required by
          applicable law or regulation, or (ii) as to the Token Sale alone, if
          less than the required quantity of USDC as determined by the Company
          have been received by the Company during the Sale Period.{" "}
        </p>
        <p>
          {" "}
          If (i) or (ii) occurs, then the USDC or other cryptocurrency sent by
          you to purchase Tokens may be returned and the purchase and sale of
          the Tokens may be considered void and rescinding without further
          recourse against the Company. We reserve the right to refuse or cancel
          Token purchase requests at any time at our sole and absolute
          discretion and to stop the Token Sale entirely for any reason, or no
          reason. To the extent that we refuse or reject a payment, we will
          exercise reasonable endeavors to secure that the payment is returned
          to the Wallet from which it was made. However, we do not warrant,
          represent, or offer any assurances that we will be able to
          successfully recover and/or return such payments, and, in any event,
          you accept that any return of your payment will be net of any fees
          applied at the time the payment is made and thereafter until returned
          (if so returned).
        </p>

        <h5>5. Sale Procedures and Specifications</h5>
        <p>
          <b>Quantity of Tokens:</b> Company will generate 10 Billion RXG as
          native tokens on the Base blockchain for use with the Rexla Globals
          services provided via the Rexla Hub The distribution of Tokens is
          outlined in our Whitepaper.
        </p>
        <p>
          All RXG will have equal value and utility within the Rexla Ecosystem.
        </p>
        <p>
          <b>Commencement and Duration of Token Sale:</b> The commencement of
          the Token Sale Period will be advertised on the Company’s website at
          <Link to="/ico">
            <b>https://rexla.com/ico</b>
          </Link>
          . The Token Sale will continue until either (i) the remaining supply
          of RXG available for sale, are sold, or (ii) the Company advertises a
          completion date. Notification of a completion date by the Company will
          be provided with at least 14 days notice, prior to the advertised
          date.
        </p>
        <p>
          <b>Procedures for Purchasing RXG:</b> In order to purchase RXG during
          the Sale Period, and to receive the RXG you purchase, you must have a
          Wallet that supports Base Network native tokens on the Base Network
          blockchain. As part of your onboarding process a wallet will be
          provided for you to use. The Company reserves the right to prescribe
          additional wallet requirements.
        </p>
        <p>
          At commencement of the Sale Period, the Company will make a link
          available on our website at{" "}
          <Link to="/ico">
            <b>https://rexla.com/ico</b>
          </Link>
          , where Token purchasers can register and complete the KYC
          requirements. The registration process may require the purchaser to
          supply their Token Receipt Address. Once the Sale Period has commenced
          a Token Deposit Address will be supplied by the Company. The Token
          Deposit Address may be a common use address or individualised for each
          participant.
        </p>
        <p>
          To initiate a purchase of RXG during the Sale Period, you must send an
          amount of USDC <b>on Base Network</b> to the Token Deposit Address
          specified to you after you agree to these Terms through the acceptance
          process described on our website.
        </p>
        <p>
          Tokens will not be distributed immediately following the Sale Period,
          but will begin following the TGE, at a time specified by Company after
          completion of the Sale Period. Any Tokens that become available after
          the TGE and a subsequent vesting period, will be accessible using a
          claim process to be described by Company and published to the Company
          website at{" "}
          <Link to="/ico">
            <b>https://rexla.com/ico</b>
          </Link>
          , prior to the TGE.
        </p>
        <p>
          The Token claim process may automatically deliver the corresponding
          amount of RXG to either (i) the Wallet address from which the USDC was
          sent, or (ii) your registered Token Receipt Address. The USDC must be
          sent to the correctly advertised Token Deposit Address during the Sale
          Period in order to purchase and receive RXG.{" "}
        </p>
        <p>
          Sending USDC to any other address may result in loss of funds.
          Attempted transactions to purchase RXG may be rejected if USDC is sent
          to the Token Deposit Address at any time before or after the Sale
          Period.{" "}
        </p>

        <h5>6. No Liability</h5>
        <p>
          La-Rex Limited, its affiliates, and its officers shall not be liable
          for any loss or damage arising from your participation in the presale
          or use of the website. You agree to indemnify and hold harmless La-Rex
          Limited from any claims, damages, or expenses arising from your breach
          of these Terms.
        </p>

        <h5>7. Security</h5>
        <p>
          <b>Your Security:</b> You are responsible for implementing reasonable
          measures for securing the wallet, vault or other storage mechanisms
          you use to receive and hold Tokens you purchase from us, including any
          requisite private key(s) or other credentials necessary to access such
          storage mechanism(s). If your private key(s) or other access
          credentials are lost, you may lose access to your Tokens. We are not
          responsible for any such losses. You will implement reasonable and
          appropriate measures designed to secure access to (i) any device
          connected with the email address associated with your account, (ii)
          private keys required to access any relevant Base Network address or
          your Tokens and (iii) your username, password and any other login or
          identifying credentials, including those used by Rexla service
          providers.
        </p>

        <h5>8. Your information</h5>
        <p>
          We may use aggregate statistical information about your activity,
          including your activity on the Company Site and logins to various
          websites, for marketing or any other purpose at our sole discretion.
          We may use your internet protocol address to verify your purchase of
          Tokens. However, we will not release your personally-identifying
          information to any third party without your consent, except as not
          prohibited by law or as set forth in these Terms, our Privacy Policy
          or any other Platform Terms and Policies, all of which you have agreed
          to.
        </p>

        <h5>9. Taxes</h5>
        <p>
          The Purchase Price that you pay for Tokens is exclusive of all
          applicable taxes. You are solely responsible for determining what, if
          any, taxes apply to your purchase of Tokens, including, for example,
          sales, use, value added, and similar taxes. It is also your
          responsibility to withhold, collect, report and remit the correct
          taxes to the appropriate tax authorities. We are not responsible for
          withholding, collecting, reporting or remitting any sales, use, value
          added or similar tax arising from your purchase of Tokens. You agree
          not to hold the Company or any Company Parties (defined below) liable
          for any tax liability associated with or arising from the creation,
          ownership, use or liquidation of Tokens, or any other action or
          transaction related to the Platform.
        </p>

        <h5>10. Intellectual Property</h5>
        <p>
          All content on <Link to="/ico">https://rexla.com/ico</Link> including
          text, graphics, logos, and images, is the property of LA-Rex Limited
          or its licensors and is protected by copyright and intellectual
          property laws.
        </p>

        <h5>11. Changes to the Terms</h5>
        <p>
          LA-Rex Limited has the right to update and modify these Terms at any
          time. We will provide notice of any significant changes, and your
          continued use of the website following such changes will constitute
          your acceptance of the new Terms.
        </p>

        <h5>12. Governing Law</h5>
        <p>
          These Terms shall be governed by and construed in accordance with the
          laws of the jurisdiction where La-Rex Limited is registered, without
          regard to its conflict of law provisions.
        </p>

        <h5>13. Representations and Warranties</h5>
        <p>By purchasing Tokens, you represent and warrant that:</p>
        <ul className="number-order">
          <li>
            You are agreeing to participate in the Platform in some manner, and
            you understand that it is your responsibility to participate,
            meaning that the Platform surrounding this project is NOT solely
            dependent upon the efforts of the Company managers, but by the
            members engaging with the Company, the Platform and any associated
            Services;
          </li>
          <li>
            You have sufficient understanding of cryptographic tokens, token
            storage mechanisms (such as token wallets), and distributed ledger
            technology to understand these Terms and to appreciate the risks and
            implications of purchasing the Tokens;
          </li>
          <li>
            You have read and understand these Terms (including the totality of
            the White Paper to which these Terms also apply);
          </li>
          <li>
            You have obtained sufficient information about the Tokens to make an
            informed decision to purchase the Tokens;
          </li>
          <li>
            You understand that the Tokens currently only confer the right to
            transfer value within the Platform and confer no other rights of any
            form with respect to the Platform or the Company, including, but not
            limited to, any voting, distribution, redemption, liquidation,
            proprietary (including all forms of intellectual property), or other
            financial or legal rights;
          </li>
          <li>
            You understand that while decentralised governance of the Platform
            is described as part of the roadmap in the White Paper, as the
            governance process is not yet defined, there is no assurance that
            ownership of Tokens will confer any rights to participate in the
            governance process once it is established, unless described as such
            in the definition of the Platform governance process, once, and if,
            that phase of the project is completed;
          </li>
          <li>
            You are not purchasing Tokens for any uses or purposes other than to
            transfer value within the Platform, including, but not limited to,
            any investment, speculative or other financial purposes.
          </li>
          <li>
            Your purchase of Tokens complies with applicable law and regulation
            in your jurisdiction, including, but not limited to, (i) legal
            capacity and any other threshold requirements in your jurisdiction
            for the purchase of the Tokens and entering into contracts with us,
            (ii) any foreign exchange or regulatory restrictions applicable to
            such purchase, and (iii) any governmental or other consents that may
            need to be obtained;
          </li>
          <li>
            You are legally permitted to receive software and participate in the
            use of the Platform;
          </li>
          <li>
            You will comply with any applicable tax obligations in your
            jurisdiction that may be relevant to your purchase, holding,
            redemption, sale, or transfer of the Tokens;
          </li>
          <li>
            You agree to promptly provide to the Company or its nominee, upon
            request, proof of identity and/or source of funds and/or other
            documentation or other information that the Company may request from
            time to time in connection with the Company’s obligations under, and
            compliance with, applicable laws and regulations, including but not
            limited to anti-money laundering legislation, regulations or
            guidance and/or tax information reporting or withholding
            legislation, regulations or guidance;
          </li>
          <li>
            You are of an age to legally contract in your country of residence
            and additionally are legally able to obtain and use the Tokens;
          </li>
          <li>
            You understand with regard to Tokens, that we make no guarantees
            that you will be able to resell Tokens, or as to its future value,
            and that no market liquidity may be guaranteed and that the value of
            Tokens over time may experience extreme volatility or depreciate in
            full;
          </li>
          <li>
            You understand that you bear the sole responsibility to determine
            whether your interactions with the Platform, the ownership or use of
            the Tokens, the potential appreciation or depreciation in the value
            of the Tokens over time, the sale and purchase of the Tokens and/or
            any other action or transaction related to the Platform may have tax
            implications; further, by obtaining, holding or using the Tokens,
            and to the extent permitted by law, you agree not to hold any third
            party (e.g., developers, auditors, contractors, or founders) liable
            for any tax liability associated with or arising from the ownership
            or use of the Tokens or any other action or transaction related to
            the Platform;
          </li>
          <li>
            You waive the right to participate in a class action lawsuit or a
            classwide arbitration against any entity or individual involved with
            the creation of the Tokens, as discussed more fully here;
          </li>
          <li>
            You understand that the purchase of Tokens does not involve the
            purchase of shares or any equivalent in any existing or future
            public or private company, corporation or other entity in any
            jurisdiction;
          </li>
          <li>
            You understand that the transfer of USDC the transfer of the Tokens
            and the maintenance of the Platform carry significant financial,
            regulatory and reputational risks as further set forth in the Terms;
          </li>
          <li>
            You understand that you have no right against any other party to
            request any refund of contributions submitted for the purchase of
            Tokens under any circumstance;
          </li>
          <li>
            If you are purchasing Tokens on behalf of a legal entity, you are
            authorised to accept these Terms on such entity’s behalf and that
            such entity will be responsible for breach of these Terms by you or
            any other employee or agent of such entity (references to “you” in
            these Terms refer to you and such entity, jointly);
          </li>
          <li>
            You are not (i) a citizen or resident of a geographic area in which
            access to or use of the Platform is prohibited by applicable law,
            decree, regulation, treaty, or administrative act, (ii) a citizen or
            resident of, or located in, a geographic area that is subject to
            U.S. or other sovereign country sanctions or embargoes, or (iii) an
            individual, or an individual employed by or associated with an
            entity, identified on BIS’s Denied Persons, Unverified, or Entity
            Lists, or OFAC’s List of Specially Designated Nationals, Foreign
            Sanctions Evaders, or List of Consolidated Sanctions, or DDTC’s
            Debarred Parties List.
          </li>
          <li>
            You agree not to allow anyone to use your Wallet or share your
            credentials with any other person for the purpose of facilitating
            their unauthorised access to the Token Sale. If you do share your
            credentials with anyone we will consider their activities to have
            been authorised by you. You alone are responsible for any acts or
            omissions that occur during the Token Sale through the use of your
            credentials. We reserve the right to suspend or block your access to
            the Token Sale upon suspicion of any unauthorised access or use, or
            any attempted access or use, by anyone associated with your
            credentials.
          </li>
        </ul>

        <h5>14. Indemnification</h5>
        <ul className="letter-order">
          <li>
            To the fullest extent permitted by applicable law, you will
            indemnify, defend and hold harmless the Company and our respective
            past, present and future employees, officers, directors,
            contractors, consultants, equity holders, suppliers, vendors,
            service providers, parent companies, subsidiaries, affiliates,
            agents, representatives, predecessors, successors and assigns (the “
            <b>Company Parties</b>”) from and against all actual and threatened
            claims, lawsuits, demands, actions, investigations (whether formal
            or informal), liabilities, obligations, judgments, damages,
            penalties, interests, fees, losses, expenses (including attorneys’
            fees and expenses), and costs (including, without limitation, court
            costs, costs of settlement, and costs of pursuing indemnification
            and insurance), of every kind and nature whatsoever, whether claimed
            by Company Parties or third parties including governmental
            authorities, whether known or unknown, foreseen or unforeseen,
            matured or unmatured, or suspected or unsuspected, in law or equity,
            whether in tort, contract, or otherwise (collectively “Claims”)
            arising from or relating to (i) your acquisition or use of Tokens,
            (ii) the performance or non-performance of your responsibilities or
            obligations under these Terms, (iii) your breach or violation of
            these Terms, (iv) any inaccuracy in any representation or warranty
            made by you, (v) your violation of any rights (including, but not
            limited to, intellectual property rights) of any other person or
            entity or (vi) any act or omission of yours that is negligent,
            unlawful, or constitutes willful misconduct. This foregoing
            indemnity is in addition to, and not in lieu of, any other remedies
            that may be available to the Parties under applicable law.
          </li>
          <li>
            The Company reserves the right to exercise sole control over the
            defense, at your expense, of any claim subject to indemnification
            under Section 11(a). This indemnity is in addition to, and not in
            lieu of, any other indemnities set forth in a written agreement
            between you and the Company.
          </li>
        </ul>

        <h5>15. Disclaimers</h5>
        <p>
          TO THE FULLEST EXTENT PERMITTED BY APPLICABLE LAW AND EXCEPT AS
          OTHERWISE SPECIFIED IN A WRITING BY US, (A) THE TOKENS ARE SOLD ON AN
          “AS IS” AND “AS AVAILABLE” BASIS WITHOUT ANY WARRANTIES OR
          REPRESENTATIONS OF ANY KIND, AND WE EXPRESSLY DISCLAIM ALL WARRANTIES
          AND REPRESENTATIONS RELATING TO THE TOKENS (WHETHER EXPRESS OR
          IMPLIED), INCLUDING, WITHOUT LIMITATION, ANY IMPLIED WARRANTIES OF
          MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, TITLE AND
          NON-INFRINGEMENT, WHETHER ARISING BY LAW, COURSE OF DEALING, COURSE OF
          PERFORMANCE, USAGE OF TRADE, OR OTHERWISE; (B) WE DO NOT REPRESENT OR
          WARRANT THAT THE TOKENS ARE RELIABLE, CURRENT, ERROR-FREE, OR
          DEFECT-FREE, MEET YOUR REQUIREMENTS, OR THAT ANY DEFECTS WILL BE
          CORRECTED; AND (C) WE CANNOT AND DO NOT REPRESENT OR WARRANT THAT THE
          TOKENS OR THE DELIVERY MECHANISM FOR TOKENS ARE FREE OF VIRUSES OR
          OTHER HARMFUL COMPONENTS.
        </p>
        <p>
          NO REGULATORY AUTHORITY HAS EXAMINED OR APPROVED ANY OF THE
          INFORMATION SET FORTH IN THESE TERMS OR ANY RELATED DOCUMENTATION OR
          COMMUNICATION BY THE COMPANY. NO SUCH ACTION HAS BEEN OR WILL BE TAKEN
          UNDER THE LAWS, REGULATORY REQUIREMENTS, OR RULES OF ANY JURISDICTION.
        </p>
        <p>
          <b>
            NEITHER THESE TERMS NOR ANY RELATED DOCUMENTATION OR COMMUNICATION
            BY THE COMPANY CONSTITUTES A PROSPECTUS OR OFFERING DOCUMENT AND IS
            NEITHER AN OFFER TO SELL NOR THE SOLICITATION OF AN OFFER TO BUY ANY
            INVESTMENT OR FINANCIAL INSTRUMENT IN ANY JURISDICTION.
          </b>
        </p>
        <p>
          Some jurisdictions do not allow the exclusion of certain warranties or
          disclaimer of implied terms in contracts with consumers, so some or
          all of the exclusions of warranties and disclaimers in this Section
          may not apply to you.
        </p>

        <h5>16. Limitation of Liability</h5>
        <p>
          TO THE FULLEST EXTENT PERMITTED BY APPLICABLE LAW: (I) IN NO EVENT
          WILL COMPANY OR ANY OF THE COMPANY PARTIES BE LIABLE FOR ANY INDIRECT,
          SPECIAL, INCIDENTAL, CONSEQUENTIAL, PUNITIVE OR EXEMPLARY LOSSES OR
          DAMAGES OF ANY KIND (INCLUDING, BUT NOT LIMITED TO, WHERE RELATED TO
          LOSS OF REVENUE, INCOME OR PROFITS, DIMINUTION OF VALUE, LOSS OF USE
          OR DATA, LOSS OR DEPLETION OF GOODWILL, LOSS OF BUSINESS OPPORTUNITY,
          LOSS OF CONTRACT, DAMAGES FOR BUSINESS INTERRUPTION, LOSS OF
          ANTICIPATED SAVINGS, OR THE LIKE) ARISING OUT OF OR IN ANY WAY RELATED
          TO THE SALE OR USE OF THE TOKENS OR OTHERWISE RELATED TO THESE TERMS,
          REGARDLESS OF THE FORM OF ACTION, WHETHER BASED IN CONTRACT, TORT
          (INCLUDING, BUT NOT LIMITED TO, SIMPLE NEGLIGENCE, WHETHER ACTIVE,
          PASSIVE OR IMPUTED), OR ANY OTHER LEGAL OR EQUITABLE THEORY (EVEN IF
          THE PARTY HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES AND
          REGARDLESS OF WHETHER SUCH DAMAGES WERE FORESEEABLE); AND (II) IN NO
          EVENT WILL THE AGGREGATE LIABILITY OF COMPANY AND THE COMPANY PARTIES
          (JOINTLY), WHETHER IN CONTRACT, WARRANTY, TORT (INCLUDING NEGLIGENCE,
          WHETHER ACTIVE, PASSIVE OR IMPUTED), OR OTHER THEORY, ARISING OUT OF
          OR RELATING TO THESE TERMS OR THE USE OF OR INABILITY TO USE THE
          TOKENS, EXCEED THE AMOUNT YOU PAY TO US FOR THE TOKENS.
        </p>
        <p>
          THE LIMITATIONS SET FORTH IN THIS SECTION 13 WILL NOT LIMIT OR EXCLUDE
          LIABILITY FOR THE GROSS NEGLIGENCE, FRAUD OR INTENTIONAL, WILLFUL OR
          RECKLESS MISCONDUCT OF COMPANY.
        </p>
        <p>
          Some jurisdictions do not allow the limitation or exclusion of
          liability for incidental or consequential damages. Accordingly, some
          of the limitations of this Section may not apply to you.
        </p>

        <h5>17. Release</h5>
        <p>
          To the fullest extent permitted by applicable law, you release the
          Company and the other Company Parties from responsibility, liability,
          claims, losses, demands and/or damages (actual and consequential) of
          every kind and nature, known and unknown (including, but not limited
          to, claims of negligence), arising out of or related to disputes
          between you and the acts or omissions of third parties.{" "}
        </p>
        <p>
          A general release does not extend to claims which the creditor does
          not know or suspect to exist in his or her favour at the time of
          executing the release, which if known by him or her must have
          materially affected his or her settlement with the debtor.
        </p>

        <h5>18. Governing Law and Venue</h5>
        <p>
          These Terms will be governed by and construed and enforced in
          accordance with the laws of the British Virgin Islands (“<b>BVI</b>”),
          without regard to conflict of law rules or principles (whether of the
          BVI or any other jurisdiction) that would cause the application of the
          laws of any other jurisdiction. Any Dispute between the Parties
          arising out of or relating to these Terms that is not subject to
          arbitration or cannot be heard in small claims court will be resolved
          and filed only in the courts of the BVI. You hereby irrevocably and
          unconditionally consent and submit to the exclusive jurisdiction of
          such courts over any suit, action or proceeding arising out of these
          Terms.
        </p>

        <h5>19. Severability</h5>
        <p>
          If any term, clause, or provision of these Terms is held to be
          illegal, invalid, void, or unenforceable (in whole or in part), then
          such term, clause, or provision shall be severable from these Terms
          without affecting the validity or enforceability of any remaining part
          of that term, clause, or provision, or any other term, clause, or
          provision in these Terms, which will remain in full force and effect.
          Any invalid or unenforceable provisions will be interpreted to affect
          the intent of the original provisions. If such construction is not
          possible, the invalid or unenforceable provision will be severed from
          these Terms, but the rest of these Terms will remain in full force and
          effect.
        </p>

        <h5>20. RISK DISCLOSURES</h5>
        <ul className="number-order">
          <li>
            <b>Risk of Losing Access to RXG Due to Wallet Incompatibility:</b> A
            valid Base Network address from a native token compatible wallet is
            required to receive your RXG. Non-compatible wallet addresses will
            not be accepted. In addition, the Base Network address used must not
            be associated with a third-party exchange or service that has
            custody over the private key (e.g. Binance/Kraken etc.). You must
            own the private key if your address is an exchange address.
          </li>
          <li>
            <b>Risks Associated with the Base Network Blockchain:</b> RXG and
            the Platform operate on the Base Network – a layer 2 blockchain
            built on Ethereum. As such, any malfunction, unintended function,
            unexpected functioning of or attack on the Network may cause the
            Platform or RXG to malfunction or function in an unexpected or
            unintended manner. Base Network/Ethereum may be the target of
            malicious attacks seeking to identify and exploit weaknesses in the
            software, which may result in the loss or theft of RXG. such attacks
            may materially and adversely affect the Platform and the utility of
            the RXG.
          </li>
          <li>
            <b>Risks Associated with Purchaser Credentials:</b> Any third party
            that gains access to or learns of your wallet credentials or private
            keys may be able to dispose of your RXG. To minimize this risk, you
            should guard against unauthorized access to your electronic devices.
            Best practices dictate that you safely store private keys in one or
            more backup locations geographically separated from the working
            location. In addition, you are responsible for giving us the correct
            Token Receipt Address to send you your RXG. If you give us the
            incorrect Token Receipt Address to send your RXG to, we are not
            responsible for any loss that may occur.
          </li>
          <li>
            <b>
              Risk of Unknowable or Unfavorable Regulatory Action in One or More
              Jurisdictions:
            </b>{" "}
            Regulation of tokens (including the Tokens), token offerings, or
            SAFT offerings, cryptocurrencies, blockchain technologies, and
            cryptocurrency exchanges is not yet mature and likely to rapidly
            evolve, varies significantly among international, federal, state and
            local jurisdictions, and is subject to significant uncertainty.
            Various legislative and executive bodies in the United States and in
            other countries may in the future adopt laws, regulations, guidance,
            or other actions, which may severely impact the development and
            growth of the Platform and the adoption and utility of the Tokens.
            Failure by the Company or certain users of the Platform to comply
            with any laws, rules, and regulations, some of which may not exist
            yet or are subject to interpretation and may be subject to change,
            could result in a variety of adverse consequences, including civil
            penalties and fines. As distributed ledger networks and distributed
            ledger assets have grown in popularity and in market size, federal
            and state agencies have begun to take an interest in and, in some
            cases, regulate their use and operation. To the extent that a
            domestic government or quasi-governmental agency exerts regulatory
            authority over a distributed ledger network or asset, the Platform
            and Tokens may be materially and adversely affected. Distributed
            ledger networks also face an uncertain regulatory landscape in many
            jurisdictions such as the United States, the European Union, China,
            and Russia. Various foreign jurisdictions may, in the near future,
            adopt laws, regulations or directives that affect the Platform. Such
            laws, regulations or directives may be in conflict with each other
            or may directly and negatively impact our business. The effect of
            any future regulatory change is impossible to predict, but such
            change could be substantial and materially adverse to the
            development and growth of the Platform and the adoption and utility
            of the Tokens. <br />
            New or changing laws and regulations or interpretations of existing
            laws and regulations, in the United States and other jurisdictions,
            may materially and adversely impact the value of the currency in
            which the Tokens may be exchanged, the liquidity and use of the
            Tokens, and the structure, rights, and transferability of Tokens
          </li>
          <li>
            <b>Risk of Alternative Platform:</b> It is possible that alternative
            platforms could be established that utilise the same or similar
            open-source code underlying the Platform and attempt to facilitate
            services that are materially similar to the Services on the
            Platform. The Platform may compete with these alternative platforms,
            which could negatively impact the Platform and the Tokens.
          </li>
          <li>
            <b>Risk of Insufficient Interest in RXG & Rexla Hub:</b> It is
            possible that the Platform will not be used by a large number of
            businesses, individuals, and other organisations and that there will
            be limited public interest in purchasing NFTs to fund housing
            developments. Because the success of the Platform also depends, in
            part, on the growth and adoption of the use of the Base Network,
            such a lack of interest could negatively impact RXG and the
            Platform.
          </li>
          <li>
            <b>
              Risk that the Platform, as Developed, Will Not Meet the
              Expectations of the Company or the Purchaser:
            </b>{" "}
            The Platform may undergo significant changes over time. Moreover, we
            may limit control over how other participants will use the Platform,
            what services may be offered through the Platform by third parties,
            or how third-party services will utilise the Tokens (if at all).
            This could create the risk that Tokens or the Platform may not meet
            your expectations at the time of purchase, for any number of reasons
            including mistaken assumptions or analysis, a change in the design
            and implementation plans, and execution of the Platform.
            Furthermore, despite our good faith efforts to develop, complete,
            and participate in the Platform, it is still possible that the
            Platform will experience malfunctions or otherwise fail to be
            adequately developed or maintained, which may negatively impact the
            Platform and Tokens, and your Tokens may become useless due to
            technical, commercial, regulatory or any other reasons.
          </li>
          <li>
            <b>Risks from Taxation:</b> The tax characterisation of RXG is
            uncertain. You must seek your own tax advice in connection with the
            acquisition, storage, transfer, and use of RXG, which may result in
            adverse tax consequences to you, including, without limitation,
            withholding taxes, transfer taxes, value added taxes, income taxes
            and similar taxes, levies, duties, or other charges and tax
            reporting requirements.
          </li>
          <li>
            <b>Risk of Theft and Hacking:</b> Hackers or other groups or
            organisations or countries may attempt to interfere with the
            Platform or the availability of RXG in any number of ways, including
            service attacks, denial of service attacks, Sybil attacks, spoofing,
            smurfing malware attacks, or consensus-based attacks, or phishing,
            or other novel methods that may or may not be known to steal RXG.
            Any such successful attacks could result in theft or loss of your
            payment of USDC or your Tokens, adversely impacting the ability to
            develop the Platform and derive any usage or functionality from the
            Tokens.
          </li>
          <li>
            <b>
              Risk of Weaknesses or Exploitable Breakthroughs in the Field of
              Cryptography:
            </b>{" "}
            Advances in cryptography, or technical advances such as the
            development of quantum computers, could present risks to RXG and the
            Platform by rendering ineffective the cryptographic consensus
            mechanism that underpins the Ethereum and Base blockchain. Smart
            contracts and their underlying software application are still in an
            early development stage and may be unproven. There is no warranty or
            assurance that the process for obtaining or using RXG will be
            uninterrupted or error-free, and there is an inherent risk that the
            software could contain defects, weaknesses, vulnerabilities,
            viruses, or bugs causing, inter alia, the complete loss of any USDC
            you contribute, the theft or loss of your Tokens, or a reduction in
            the utility of your Tokens.
          </li>
          <li>
            <b>Risk of Uninsured Losses:</b> Unlike bank accounts or accounts at
            some other financial institutions, funds held using the Platform or
            Base Network are generally uninsured. In the event of any loss,
            there is no public insurer, such as the Federal Deposit Insurance
            Corporation/Financial Services compensation scheme, or private
            insurer, to offer recourse to the purchaser.
          </li>
          <li>
            <b>Risks Arising from Lack of Governance Rights:</b> Because Tokens
            currently confer no governance rights of any kind with respect to
            the Platform or the Company, all decisions involving the Company’s
            products or services within the Platform or the Company itself will
            be made by the Company at its sole discretion, including, but not
            limited to, decisions to discontinue its products or services on the
            Platform, to create and sell more Tokens for use on the Platform, or
            to sell or liquidate the Company. These decisions could adversely
            affect the Platform and the utility of any Tokens you own, including
            their utility for obtaining Services.
            <br />
            <b>Risks Associated with Data Privacy Laws:</b> There are a number
            of data protection, security, privacy and other government- and
            industry-specific requirements, including those that require
            companies to notify individuals of data security incidents involving
            certain types of personal data. Security compromises could harm the
            Platform’s reputation, erode user confidence in the effectiveness of
            its security measures, negatively impact its ability to attract new
            users, or cause existing users to stop using the Platform, which
            would reduce or diminish the utility of the Tokens and cause the
            Platform to fail.
          </li>
          <li>
            <b>Unanticipated Risks:</b> Cryptographic tokens are a relatively
            new and untested technology. In addition to the risks discussed in
            these Terms, there are risks that the La-Rex team cannot anticipate.
            Further risks may materialise as unanticipated combinations or
            variations of the discussed risks or the emergence of new risks.
          </li>
        </ul>
      </div>

      <h4>Contact</h4>
      <p>
        For any further information please contact us using{" "}
        <a href="mailto:Support@Rexla.com">Support@Rexla.com</a>
      </p>
    </div>
  );
};

export default TokenTerms;
